export default __webpack_public_path__ + "static/media/reporte.0ed6c876.PNG";